import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ChannelLinks({ userData, handleSocialChange }) {
  const landingPage = import.meta.env.VITE_LANDING_PAGE;

  return (
    <>
      <div className="space-y-2 w-full">
        <h1
          className={`text-3xl text-left font-medium no-animation ${
            landingPage === "adcelerate" ? "text-primary" : landingPage === "creatorshield" ? "text-black" : "text-white"
          }`}
        >
          Channel Links
        </h1>
        <p
          className={`text-lg ${
            landingPage === "adcelerate" ? "text-primary" : ""
          }`}
        >
          Connect the platforms where you publish your content.
        </p>
      </div>
      <div className="flex flex-col gap-6 my-10 w-full">
        <div className="flex flex-col md:flex-row gap-6">
          <div className="space-y-2 w-full">
            <Label
              className={`text-base ${
                landingPage === "adcelerate" ? "text-[#757575]" : ""
              }`}
              htmlFor="youtube"
            >
              Youtube Link
            </Label>
            <Input
              className="p-6 rounded-md focus-visible:ring-1 focus-visible:ring-[var(--primary)] bg-white text-black border border-gray-200"
              value={userData.socials.youtube}
              onChange={handleSocialChange}
              id="youtube"
              type="text"
              placeholder="https://www.youtube.com/@yourchannelname"
            />
          </div>
          <div className="space-y-2 w-full">
            <Label
              className={`text-base ${
                landingPage === "adcelerate" ? "text-[#757575]" : ""
              }`}
              htmlFor="tiktok"
            >
              TikTok Link
            </Label>
            <Input
              className="p-6 rounded-md focus-visible:ring-1 focus-visible:ring-[var(--primary)] bg-white text-black border border-gray-200"
              value={userData.socials.tiktok}
              onChange={handleSocialChange}
              id="tiktok"
              type="text"
              placeholder="https://www.tiktok.com/@yourusername"
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-8 md:gap-6">
          <div className="space-y-2 w-full">
            <Label
              className={`text-base ${
                landingPage === "adcelerate" ? "text-[#757575]" : ""
              }`}
              htmlFor="twitchTv"
            >
              Twitch TV
            </Label>
            <Input
              className="p-6 rounded-md focus-visible:ring-1 focus-visible:ring-[var(--primary)] bg-white text-black border border-gray-200"
              value={userData.socials.twitchTv}
              onChange={handleSocialChange}
              id="twitchTv"
              type="text"
              placeholder="https://www.twitch.tv/yourchannelname"
            />
          </div>
          <div className="space-y-2 w-full">
            <Label
              className={`text-base ${
                landingPage === "adcelerate" ? "text-[#757575]" : ""
              }`}
              htmlFor="instagram"
            >
              Instagram Link
            </Label>
            <Input
              className="p-6 rounded-md focus-visible:ring-1 focus-visible:ring-[var(--primary)] bg-white text-black border border-gray-200"
              value={userData.socials.instagram}
              onChange={handleSocialChange}
              id="instagram"
              type="text"
              placeholder="https://www.instagram.com/yourusername"
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-8 md:gap-6">
          <div className="space-y-2 w-full">
            <Label
              className={`text-base ${
                landingPage === "adcelerate" ? "text-[#757575]" : ""
              }`}
              htmlFor="facebook"
            >
              Facebook Link
            </Label>
            <Input
              className="p-6 rounded-md focus-visible:ring-1 focus-visible:ring-[var(--primary)] bg-white text-black border border-gray-200"
              value={userData.socials.facebook}
              onChange={handleSocialChange}
              id="facebook"
              type="text"
              placeholder="https://www.facebook.com/yourpagename"
            />
          </div>
          <div className="space-y-2 w-full">
            <Label
              className={`text-base ${
                landingPage === "adcelerate" ? "text-[#757575]" : ""
              }`}
              htmlFor="douyin"
            >
              Douyin Link
            </Label>
            <Input
              className="p-6 rounded-md focus-visible:ring-1 focus-visible:ring-[var(--primary)] bg-white text-black border border-gray-200"
              value={userData.socials.douyin}
              onChange={handleSocialChange}
              id="douyin"
              type="text"
              placeholder="https://www.douyin.com/user/yourid"
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-8 md:gap-6">
          <div className="space-y-2 w-full">
            <Label
              className={`text-base ${
                landingPage === "adcelerate" ? "text-[#757575]" : ""
              }`}
              htmlFor="kuaishou"
            >
              Kuaishou
            </Label>
            <Input
              className="p-6 rounded-md focus-visible:ring-1 focus-visible:ring-[var(--primary)] bg-white text-black border border-gray-200"
              value={userData.socials.kuaishou}
              onChange={handleSocialChange}
              id="kuaishou"
              type="text"
              placeholder="https://www.kuaishou.com/profile/yourid"
            />
          </div>
          <div className="space-y-2 w-full">
            <Label
              className={`text-base ${
                landingPage === "adcelerate" ? "text-[#757575]" : ""
              }`}
              htmlFor="rumble"
            >
              Rumble Link
            </Label>
            <Input
              className="p-6 rounded-md focus-visible:ring-1 focus-visible:ring-[var(--primary)] bg-white text-black border border-gray-200"
              value={userData.socials.rumble}
              onChange={handleSocialChange}
              id="rumble"
              type="text"
              placeholder="https://rumble.com/c/yourchannelname"
            />
          </div>
        </div>
        <div className="space-y-2 w-full">
          <Label
            className={`text-base ${
              landingPage === "adcelerate" ? "text-[#757575]" : ""
            }`}
            htmlFor="others"
          >
            Other Links (Google Drive, OneDrive, DropBox, etc.)
          </Label>
          <Input
            className="p-6 rounded-md focus-visible:ring-1 focus-visible:ring-[var(--primary)] bg-white text-black border border-gray-200"
            value={userData.socials.others}
            onChange={handleSocialChange}
            id="others"
            type="text"
            placeholder="Deliver any other content here that you would like to boost"
          />
        </div>
      </div>
    </>
  );
}
